/* eslint-disable */
import axios from './axios';
import utils from '../lib/utils';

export default {
  axios,
  // 获取用户收货地址列表
  getUserAddressList(params) {
    console.log(params);
   
    return axios.get(`/onlineDrug/address/getUserAddressList?${utils.exchangeParams(params)}`);
  },
  // 获取地址详情
  getUserAddressById(params) {
    return axios.get(`/onlineDrug/address/getAddressInfoById?${utils.exchangeParams(params)}`);
  },
  // 修改收货地址/编辑收货地址
  updateUserAddressById(params) {
    console.log(params);
    return axios.post('/onlineDrug/address/editUserAddressById', params);
  },
  // 添加收货地址
  addAddress(params) {
    return axios.post('/onlineDrug/address/addAddress', params);
  },

  // 物流详情测试接口
  orderOnlineByJson(params) {
    return axios.post('/onlineDrug/orderOnlineByJson', params)
  }
  

};
